import styles from "./MobileMenu.module.css";

const MobileMenu = (props) => {
  const clickMobileMenuHandler = (event) => {
    let element;
    const className = event.target.className;
    if (className === "mobile-menu-list") {
      element = event.target.parentElement;
    } else {
      element = event.target;
    }
    element.classList.toggle(styles["active"]);

    if (
      element.className.indexOf("active") === -1
    ) {
      return props.onShowNavigation(false);
    }
    return props.onShowNavigation(true);
  };
  return (
    <ul
      className={styles["mobile-menu"]}
      onClick={clickMobileMenuHandler}
    >
      <li className="mobile-menu-list"></li>
      <li className="mobile-menu-list"></li>
      <li className="mobile-menu-list"></li>
    </ul>
  );
};

export default MobileMenu;
